/**
 * dev-ops-aware-devices-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T23:28:47Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * a count of the number of each type of peripheral that has reported
 */
export interface PeripheralCounts { 
    /**
     * a count of the number of low impedance fault sensor peripherals in the system
     */
    ifdLowImpedanceFault: number;
    /**
     * a count of the number of TempPatrol peripherals in the system
     */
    temperature: number;
}
